import makeStyles from '@mui/styles/makeStyles';

export const useGlobalSearchStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'flex-end',
    marginLeft: '8px',
    [theme.breakpoints.up('xl')]: {
      marginRight: '8px',
    },
  },
}));
